import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';

export const Geolocation = defineComponent({
  name: 'Geolocation',
  setup() {
    return function render() {
      return h('div', [`*${t('form.geolocation-warning')}`]);
    };
  },
});
